import React, {Component} from "react";

class ProjectTable extends Component{
  static defaultProps = {
    header: [],
    data: []
  }
  constructor(props) {
    super(props);
    this.state = props;
  }
  reloadData = (data) =>{
    this.setState({data})
  }
  render() {
    const {header, data}= this.state;
    return <div className="ProjectTable">
      <div className="table-content">
        <div className="content-header">
          <div className="header-tr">
            {
              header.map(res=>{
                return <div className={`header-td ${res.customStyle}`} style={{width: res.width}}>{res}</div>
              })
            }
          </div>
        </div>
        <div className="content-body">
          {
            data.map(res=>{
              return <div className="body-tr">
                {
                  res.map(res1=>{
                    return <div className={`body-td`}>{res1}</div>
                  })
                }
              </div>
            })
          }
        </div>
      </div>
    </div>
  }
}

export default ProjectTable;